import Popup from "./Popup";
import Reviews from "./Reviews";
import GoogleReviews from "./GoogleReviews";
import { Helmet } from "react-helmet";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Touch Massage</title>
        <link rel="canonical" href="https://touch-massagetherapy.com/" />
      </Helmet>

      <Popup trigger={false}>
        <header>
          <h2 className="center-text fancy-font">
            🌧️Anniversary Party Postponed
          </h2>
        </header>
        <div className="center-text">
          <p>
            Due to the weather forecast, we have decided to postpone our
            anniversary party. We will be rescheduling for a later date and will
            update everyone as soon as we have a new date set. Thank you for
            your understanding!
          </p>
          <div
            style={{
              width: "70%",
              margin: "auto",
              paddingTop: "30px",
            }}
          >
            <img
              src={require("../images/logo.webp")}
              alt="Touch Massage Therapy Logo"
              fetchpriority="high"
              className="logo"
            />
          </div>
        </div>
      </Popup>

      <section id="main">
        <h1 className="fancy-font fancy-bold big-text-1">Relax</h1>
        <span className="indent-1 fancy-font fancy-bold big-text-1">
          Rejuvenate
        </span>
        <h1 className="indent-2 fancy-font fancy-bold big-text-1">
          Relieve your tension
        </h1>
        <div className="main-buttons">
          <button>
            <a href="/policies">Book Now</a>
          </button>
        </div>
      </section>

      <section id="biz-summary">
        <p className="center-text">
          <span className="bold">Touch Massage</span> is a welcoming,
          client-focused massage studio dedicated to helping you feel your best.
          Our skilled licensed massage therapists offer a range of personalized
          services, from relaxation-focused Swedish massage to targeted
          therapeutic bodywork designed to address pain, tension, and stress.
          Whether you’re looking to recover from an intense workout, ease
          chronic discomfort, or simply take time for self-care, our team will
          tailor your session to your unique needs.
          <br />
          <br />
          We believe massage should be approachable and accessible, with a
          down-to-earth, comfortable atmosphere where you can relax and
          recharge. Our goal is to help you move better, feel better, and live
          better — one massage at a time.
          <br />
          <br />
          Come experience why our clients trust us as part of their wellness
          routine.
        </p>
      </section>

      <section id="testimonials">
        <div className="center-text testimonials-header">
          Customize your therapy session, massage, facial, or exfoliating
          session to create your very own unique experience
        </div>
        <br />
        <br />
        {/* <h1 className="center-text fancy-font big-text-2 glow">
          What our clients are saying about us:
        </h1> */}
        <br />
        {/* Google Reviews */}
        {/* <div>
          <h2 className="center-text">Google Reviews</h2>
          <GoogleReviews />
        </div> */}
        {/* MindBody Reviews */}
        {/* <div>
          <h2 className="center-text">MindBody Reviews</h2>
          <Reviews />
        </div> */}

        <div className="testimonials-footer">
          <div>
            <h4>Book online or call us at</h4>
            <span className="big-text-3">469-520-0012</span>
          </div>

          <button>
            <a href="/policies">Book Now</a>
          </button>
          <address>
            <span className="bold">Touch Massage</span>
            <br />
            522 Pinson Rd.
            <br />
            Forney, TX 75126
            <br />
            Phone: <a href="tel:469-520-0012">(469) 520-0012</a>
            <br />
            <a href="mailto:info@touch-massagetherapy.com">
              {" "}
              info@touch-massagetherapy.com
            </a>
          </address>
        </div>
      </section>
    </>
  );
};

export default Home;
